module.exports = "/lucky-balls/img/purple-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/purple-ball.png
// module id = 102
// module chunks = 0